import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import API from '../services/api';

const CategoryModal = ({ onClose, onCreated }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      const res = await API.post('/categories', { name, description });
      onCreated(res.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al guardar la categoría.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Nueva Categoría</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-2">
            <Form.Label>Nombre</Form.Label>
            <Form.Control value={name} onChange={e => setName(e.target.value)} required autoFocus />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Descripción</Form.Label>
            <Form.Control as="textarea" rows={2} value={description} onChange={e => setDescription(e.target.value)} />
          </Form.Group>
          <Button type="submit" className="w-100" disabled={saving}>Guardar Categoría</Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CategoryModal;
